import {useState, useEffect} from 'react'
import Fecha from './fecha_hora.js'

const Codigos = (props) => {
    const [cerrar, setCerrar] = useState(false)
    const [fecha, setFecha] = useState('')

    
    const f_selected = 'grid grid-cols-4 gap-2 justify-self-start text-sm bg-white text-red-600 w-full'
    const f_no = 'grid grid-cols-4 gap-2 justify-self-start text-sm bg-white w-full'
    const tachado = 'col-span-2 justify-self-start px-2 line-through'
    const notachado = 'col-span-2 justify-self-start px-2'

    
    const guardar = () => {
        var data = {
            cerrar: cerrar,
            cierre_prog: fecha
        }
                
        const subir = {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            },
            body: JSON.stringify(data)
        }
        fetch(props.back + 'admin/guardar_usuario', subir)
        .then (response => response.json())
        .then (json => {
            
        })
    }

    useEffect(() => {
        const data = {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
        }
        fetch(props.back + 'admin/traer_cierre/' + props.evento.id, data)
        .then (response => response.json())
        .then (json => {
            setCerrar(json.cerrar)
            setFecha(json.cierre_prog)
        })
    },[props.evento, props.back, props.token])

    return (<>
    <div className='flex flex-col w-full'>
        <div className='m-3 text-lg'>
            <input type='checkbox' className={cerrar ? 'w-4 h-4 mr-5 rounded border-2 appearance-none relative cursor-pointer transition-colors duration-200 bg-green-500 border-green-600' : 'w-4 h-4 mr-5 rounded border-2 appearance-none relative cursor-pointer transition-colors duration-200 bg-zinc-200  border-zinv-800'} checked={cerrar}  onChange={e => setCerrar(e.target.checked)} />
            <label className={cerrar ? 'text-green-500' : 'text-red-500'} >Forzar Cierre de Inscripción (se puede revertir)</label>
        </div>
        <div className='flex flex-col m-3 text-lg w-1/3 items-center'>
            <label className='text-lg my-2' >Programar Cierre</label>
            <Fecha fecha={fecha} setFecha={setFecha}/>
        </div>
        
    </div>
    </>)
}

export default Codigos
